import { useState } from 'react';
import { RATING_MAX, ratingLabel } from './supportLabels';

const STARS = Array.from({ length: RATING_MAX }, (_, index) => index + 1);

export const SupportStars = ({ rating }: { rating: number }) => (
  <span className="support-stars" aria-hidden="true">
    {STARS.map((star) => (
      <span key={star} className={star <= rating ? 'support-star support-star--on' : 'support-star'}>
        ★
      </span>
    ))}
  </span>
);

type Props = {
  rating: number | null;
  isSupport: boolean;
  submitting: boolean;
  onRate: (rating: number) => void;
};

/** Автор ставит оценку решённому обращению один раз; поддержка её только видит. */
const SupportRating = ({ rating, isSupport, submitting, onRate }: Props) => {
  const [hovered, setHovered] = useState(0);

  if (rating) {
    return (
      <p className="support-rating-result">
        {isSupport ? 'Оценка пользователя:' : 'Ваша оценка:'}{' '}
        <SupportStars rating={rating} /> {ratingLabel(rating)}
      </p>
    );
  }

  if (isSupport) {
    return <p className="support-rating-result">Пользователь ещё не оценил ответ</p>;
  }

  return (
    <div className="support-rating">
      <p id="support-rating-title" className="support-rating-title">
        Оцените ответ поддержки
      </p>
      <div
        className="support-rating-stars"
        role="group"
        aria-labelledby="support-rating-title"
        onMouseLeave={() => setHovered(0)}
      >
        {STARS.map((star) => (
          <button
            key={star}
            type="button"
            className={star <= hovered ? 'support-star-btn support-star-btn--on' : 'support-star-btn'}
            aria-label={ratingLabel(star)}
            disabled={submitting}
            onMouseEnter={() => setHovered(star)}
            onFocus={() => setHovered(star)}
            onBlur={() => setHovered(0)}
            onClick={() => onRate(star)}
          >
            ★
          </button>
        ))}
      </div>
    </div>
  );
};

export default SupportRating;
